import { render, staticRenderFns } from "./TipoParteSelect.vue?vue&type=template&id=2be4d4ea&"
import script from "./TipoParteSelect.vue?vue&type=script&lang=js&"
export * from "./TipoParteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports